import { Box, CircularProgress } from '@mui/material';
import React, { Component } from 'react'

class PlanoStock extends Component {
    constructor(props){
        super(props);
        this.state = {
            loading: false,
            errores: null,
            notificaciones: null,
        }
    }
    async componentDidMount(){}
    render(){
        return (
            <>
                <h3>Ingreso de Stock</h3>
                {this.state.loading
                ?
                    <div style={{placeItems: 'center'}}>
                        <Box sx={{alignItems: 'center'}}>
                            <CircularProgress/>
                        </Box>
                    </div>
                :
                    null
                }
                {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                <br/>
            </>
        )
    }
}

export default PlanoStock